export const getAuth = (state) => state.app.auth;
export const getAuthErrors = (state) => state.app.errors;
